<template>
    <div class="max-container">
        <div v-if="pacingDataExists" class="pacing-table-container">
            <h3>Pacing Table</h3>
            <div class="pagination">
                <button v-if="pageNumber !== 1" class="previous-button" @click="previous">
                    <span class="icon icon--inline icon--arrow-left"></span> Previous
                </button>
                <span class="page-number font-arial">
                    {{ pageNumber }} of {{ tableData.body.length }}
                </span>
                <button v-if="pageNumber !== tableData.body.length" class="next-button" @click="next">
                    Next <span class="icon icon--inline icon--arrow-right"></span>
                </button>
            </div>
            <div class="pacing-table">
                <transition-group :name="slideName()" tag="table" class="table" :style="{ height: `${tableHeight}px` }" @enter="setTableHeight">
                    <thead key="thead" ref="thead">
                        <tr>
                            <th v-for="heading in tableData.head" :key="heading">{{ heading }}</th>
                        </tr>
                    </thead>
                    <tbody :ref="`body${pageIndex}`" class="table-body" v-for="(page, pageIndex) in tableData.body" :key="`bodyPage${pageIndex}`" v-if="(pageNumber - 1) === pageIndex">
                        <tr v-for="(row, rowIndex) in page" :key="`${pageIndex}row${rowIndex}`">
                            <th v-for="(cell, cellIndex) in row.categories" :key="`row${rowIndex}category${cellIndex}`">{{ cell }}</th>
                            <td v-for="(cell, cellIndex) in row.values" :key="`row${rowIndex}value${cellIndex}`">{{ cell }}</td>
                        </tr>
                    </tbody>
                </transition-group>
            </div>
        </div>
        <h1 v-else class="no-data">
            No data for those filters
        </h1>
    </div>
</template>

<script>
    import store from '@/store';

    export default {
        data() {
            return {
                pageNumber: 1,
                direction: 'left',
                perPage: 10,
                tableData: {
                    head: [],
                    body: [],
                },
                // bodyEl: null,
                tableHeight: 100,
                // resizeDebounceTimer: null,
            };
        },
        computed: {
            pacingData() {
                return store.state.pacingData.data;
            },
            pacingDataExists() {
                return store.state.pacingData.data.length;
            },
        },
        mounted() {
            this.makeTable();

            // window.addEventListener('resize', () => {
            //     clearTimeout(this.resizeDebounceTimer);

            //     this.resizeDebounceTimer = setTimeout(() => {
            //     }, 200);
            // });
        },
        methods: {
            setTableHeight(el) {
                this.tableHeight = el.clientHeight + this.$refs.thead.clientHeight;
            },
            next() {
                this.direction = 'left';
                this.pageNumber += 1;
            },
            previous() {
                this.direction = 'right';
                this.pageNumber -= 1;
            },
            slideName() {
                return this.direction === 'right' ? 'slideRight' : 'slideLeft';
            },
            makeTable() {
                const uniques = {
                    categories: [],
                    values: [],
                };

                this.pacingData.forEach((datum) => {
                    Object.keys(datum.categories).forEach((keyName) => {
                        if (!uniques.categories.includes(keyName)) {
                            uniques.categories.push(keyName);
                        }
                    });

                    Object.keys(datum.values).forEach((keyName) => {
                        if (!uniques.values.includes(keyName)) {
                            uniques.values.push(keyName);
                        }
                    });
                });

                const tableHeadings = [...uniques.categories, ...uniques.values];

                const tableBody = [];

                let counter = 0;
                let page = [];

                this.pacingData.forEach((datum, index) => {
                    const row = {
                        categories: [],
                        values: [],
                    };

                    uniques.categories.forEach((category) => {
                        row.categories.push(datum.categories[category]);
                    });

                    uniques.values.forEach((value) => {
                        row.values.push(datum.values[value]);
                    });


                    counter += 1;

                    if (counter % this.perPage === 0) {
                        page.push(row);
                        tableBody.push(page);
                        page = [];
                    } else if (this.pacingData.length === (index + 1)) {
                        page.push(row);
                        tableBody.push(page);
                    } else {
                        page.push(row);
                    }
                });

                this.tableData = {
                    head: tableHeadings,
                    body: tableBody,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../assets/scss/partials/variables';

    .pacing-table-container {
        margin: 0 -#{$mobile-side-gutter};
        padding: 26px $mobile-side-gutter 33px;

        background-color: white;

        border-top-style: solid;
        border-top-width: 3px;
        border-top-color: $kpmg-blue;

        @media screen and (min-width: $tablet) {
            padding: 26px 30px 54px 30px;
            margin: 0;
        }

        @media screen and (min-width: $desktop) {
            padding: 26px 50px 54px 50px;
        }
    }

    h3 {
        margin-bottom: 26px;
        font-size: 35px;
        color: $kpmg-blue;

        @media screen and (min-width: $tablet) {
            margin-bottom: 36px;
        }
    }

    .no-data {
        margin-bottom: 43px;
        color: $kpmg-blue;
        text-align: center;
    }

    .pacing-table {
        overflow-x: auto;
    }

    .table {
        height: 458px;
        min-width: 840px;
        position: relative;
        table-layout: fixed;
        overflow: hidden;

        transition: height 0.6s ease;
    }

    .table-body {
        position: absolute;
        top: 56px;
        left: 0;
        width: 100%;

        display: table;
        table-layout: fixed;
    }

    .pagination {
        position: relative;
        text-align: center;

        margin-top: 17px;
        margin-bottom: 17px;

        button {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);

            cursor: pointer;

            &.hide {
                display: none;
            }
        }

        .previous-button {
            left: 0;
        }
        .next-button {
            right: 0;
        }

        .icon {
            vertical-align: bottom;
        }
    }

    .page-number {
        font-size: 13px;
    }

    $duration: 0.8s;

    .slideLeft-enter-active {
        transition: all $duration ease;
        transform: translateX(-100%);
        opacity: 0;
    }

    .slideLeft-leave-active {
        transition: all $duration ease;
        transform: translateX(100%);
        opacity: 0;
    }

    .slideLeft-enter {
        transform: translateX(100%);
        opacity: 0;
    }

    .slideLeft-leave-to {
        transform: translateX(-100%);
        opacity: 0;
    }


    .slideLeft-enter-to {
        transform: translateX(0);
        opacity: 1;
    }

    .slideLeft-leave {
        opacity: 1;
    }

    .slideRight-enter-active {
        transition: all $duration ease;
        transform: translateX(100%);
        opacity: 0;
    }

    .slideRight-leave-active {
        transition: all $duration ease;
        transform: translateX(-100%);
        opacity: 0;
    }

    .slideRight-enter {
        transform: translateX(-100%);
        opacity: 0;
    }

    .slideRight-leave-to {
        transform: translateX(100%);
        opacity: 0;
    }


    .slideRight-enter-to {
        transform: translateX(0);
        opacity: 1;
    }

    .slideRight-leave {
        opacity: 1;
    }
</style>



// WEBPACK FOOTER //
// src/components/PacingTable.vue